import { Component, OnInit, Input } from '@angular/core';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-note',
  templateUrl: './patient-note.component.html',
  styleUrls: ['./patient-note.component.scss']
})
export class PatientNoteComponent extends PatientComponent implements OnInit {

  @Input() note: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
